/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const required = (value: any): boolean | string => !!value || 'Pole je povinné';

export const isCZKValue = (value: any): boolean | string => Number.isInteger(Number(value)) || 'Uveďte celou číslenou hodnotu v Kč';

export const isNumber = (value: any): boolean | string => Number.isInteger(Number(value)) || 'Zadejte číselnou hodnotu';

export const isBiggerThanOrEqualFiftyThousand = (value: number): boolean | string => value >= 50000 || 'Minimální hodnota je 50 tisíc Kč';

export const isSmallerThanOrEqualHundredMillion = (value: number): boolean | string => value <= 50000000 || 'Maximální hodnota je 50 milionů Kč';

export const isSmallerThanOrEqualFiveMillion = (value: number): boolean | string => value <= 5000000 || 'Maximální hodnota je 5 milionů Kč';

export const isBiggerThanOneThousand = (value: number): boolean | string => value >= 1000 || 'Minimální hodnota je 1.000 Kč';

export const isSmallerThanQuarterMillion = (value: number): boolean | string => value <= 250000 || 'Maximální hodnota je 250 tis. Kč';

export const isSmallerThanOrEqualFiftyThousand = (value: number): boolean | string => value <= 50000 || 'Maximální hodnota je 50 tisíc Kč';

export const isBiggerThanZero = (value: number): boolean | string => value > 0 || 'Minimální hodnota je 1 Kč';

export const isLongerThanFiveCharacters = (value: any): boolean | string => (!!value && value.length > 5) || 'Zadané číslo je moc krátké';

export const isShorterThanNineCharacters = (value: any): boolean | string => (!!value && value.length < 9) || 'Zadané číslo je moc dlouhé';

export const isPhoneNumber = (value: any): boolean | string => /^\d{3} ?\d{3} ?\d{3}$/.test(value) || 'Zadejte platné telefonní číslo bez předvolby';

// eslint-disable-next-line
export const isEmailAddress = (value: any): boolean | string => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Zadejte platnou e-mailovou adresu';

export const isInCompanyRegistry = (value: any): boolean | string => !!value || 'Společnost nebyla nalezena v RŽP ani obchodním rejstříku';

// eslint-disable-next-line
export const birthNumber = (value: any): boolean | string => /^((\d{6}\/?\d{3})|(\d{6}\/?\d{4})|(\d{9}\/?\d{3}))?$/.test(value) || 'Zadejte platné rodné číslo';

export const companyId = (value: any): boolean | string => /^(\d{8})?$/.test(value) || 'Zadejte platné IČO';

export const isFullName = (value: any): boolean | string => (
  !value
  || /([a-zA-ZßüÜöÖäÄěĚšŠčČřŘžŽýÝáÁíÍéÉóÓťŤďĎúÚůŮ]{3,16})?([ ]{0,1})?([a-zA-ZßüÜöÖäÄěĚšŠčČřŘžŽýÝáÁíÍéÉóÓťŤďĎúÚůŮ]{3,16})?([ ]{0,1})?([a-zA-ßüÜöÖäÄěĚšŠčČřŘžŽýÝáÁíÍéÉóÓťŤďĎúÚůŮ]{3,16}$)/.test(value)
  || 'Zadejte platné jméno'
);

export const addressRule = (v: string) => /(.*) (.*), ?([\d]{5}) (.*)/.test(v) || 'Adresa musí být ve tvaru \'Ulice 123/4, 12345 Město 3\'';

export const isIdentityCard = (v: string) => /^[\dA-Za-z]{1,12}$/.test(v) || 'Číslo OP musí obahovat jen znaky 0-9, A-Z, a-z v délce 1-12 znaků';
